import { ExperiencePurchaseResponse } from 'types/experienceCatalog';

import { resolvePurchaseOutcome } from './purchaseOutcome';

/*
 * O que aconteceu com um pedido de troca de experiência (TRC-12 a TRC-16).
 *
 * `mantida`: a nova foi recusada e a anterior voltou. `sem_resgate`: a nova foi recusada e a
 * anterior também não voltou. O `motivo` é sempre o da recusa da NOVA, que é o que o jogador pediu.
 */
export type DesfechoDaTroca =
  | { kind: 'trocada' }
  | { kind: 'mantida'; motivo: string }
  | { kind: 'sem_resgate'; motivo: string }
  | { kind: 'cancelamento_falhou'; mensagem: string }
  | { kind: 'sem_confirmacao' };

export const CANCELAMENTO_PADRAO = 'Não foi possível cancelar o resgate. Tente novamente.';
const MOTIVO_ESGOTADA = 'esgotou a quantidade de vagas';

interface OpcoesDaTroca {
  /** Cancela o resgate atual do ciclo; rejeita com a mensagem já limpa pelo serviço. */
  cancelar: () => Promise<unknown>;
  comprar: () => Promise<ExperiencePurchaseResponse>;
  comprarAnterior: () => Promise<ExperiencePurchaseResponse>;
  restrictionMessages: Record<string, string>;
}

async function desfechoDaCompra(compra: () => Promise<ExperiencePurchaseResponse>, mensagens: Record<string, string>) {
  try {
    return resolvePurchaseOutcome(await compra(), mensagens);
  } catch (erro) {
    console.error('Erro na compra da troca de experiência:', erro);
    return { kind: 'sem_confirmacao' as const };
  }
}

/*
 * Cancela primeiro e compra depois: a `FnEN39m` recusa compra com resgate ativo, e é o
 * cancelamento que devolve os pontos que a nova compra usa. Sem confirmação da compra nova, a
 * anterior NÃO é recomprada: se a nova tiver gravado, seriam duas.
 */
export async function trocarExperiencia({ cancelar, comprar, comprarAnterior, restrictionMessages }: OpcoesDaTroca): Promise<DesfechoDaTroca> {
  try {
    await cancelar();
  } catch (erro) {
    return { kind: 'cancelamento_falhou', mensagem: (erro instanceof Error && erro.message) || CANCELAMENTO_PADRAO };
  }

  const nova = await desfechoDaCompra(comprar, restrictionMessages);
  if (nova.kind === 'confirmada') return { kind: 'trocada' };
  if (nova.kind === 'sem_confirmacao') return { kind: 'sem_confirmacao' };

  const motivo = nova.kind === 'esgotada' ? MOTIVO_ESGOTADA : nova.message;
  const anterior = await desfechoDaCompra(comprarAnterior, restrictionMessages);
  return anterior.kind === 'confirmada' ? { kind: 'mantida', motivo } : { kind: 'sem_resgate', motivo };
}
